import { render } from "./Step3.vue?vue&type=template&id=6afbbf00"
import script from "./Step3.vue?vue&type=script&lang=ts"
export * from "./Step3.vue?vue&type=script&lang=ts"
script.render = render

export default script